import React from "react";
import { cn } from "../../ui";

/**
 * SectionMark — a section's letter in a filled circle (A, B, C …), the way a
 * printed paper names its parts. Decorative: the section's name is always
 * written beside it, so the mark is hidden from screen readers.
 */
export default function SectionMark({ letter, size = "md", className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-soft tw-font-semibold tw-text-primary-soft-fg",
        size === "sm" ? "tw-h-6 tw-w-6 tw-text-xs" : "tw-h-8 tw-w-8 tw-text-sm",
        className,
      )}
    >
      {letter}
    </span>
  );
}
